module.exports = __webpack_public_path__ + "static/media/eduGreen.07e56b22.svg";